import { Logger } from './VizclientUtils';
import { MiscUtil } from './MiscUtil';

// tslint:disable-next-line:no-any
export type DelegateFuncType = (a: any, b: any) => void;

export type DelegateType<T extends DelegateFuncType> = T[];
interface SaltarelleDelegate {
  _targets: object[];
}

class Delegate<T extends DelegateFuncType> {
  private delegate: DelegateType<T> = [];

  public invoke(arg1: {} = undefined, arg2: {} = undefined): void {
    // Clone the delegates before calling them.
    // Delegates might remove themselves from the listener.
    const e = [...this.delegate];
    if (MiscUtil.IsNullOrUndefined(e)) {
      Logger.Debug('delegate type not supported');
      return;
    }
    e.forEach(function (callee: T): void {
      callee(arg1, arg2);
    });
  }

  public add(callee: T): void {
    if (MiscUtil.IsNullOrUndefined(callee)) {
      Logger.Debug('delegate to add is not initialized (null)');
      return;
    }
    this.delegate.push(callee);
  }

  public remove(callee: T): void {
    if (MiscUtil.IsNullOrUndefined(callee)) {
      Logger.Debug('delegate to remove is not initialized (null)');
      return;
    }
    const index: number = this.find(callee);
    if (index >= 0) {
      this.delegate.splice(index, 1);
    } else {
      Logger.Debug('delegate to remove is not found');
    }
  }

  private find(callee: T): number {
    let index: number = this.delegate.indexOf(callee);
    if (index < 0) {
      // Handle saltarelle generated delegates.
      // Saltarelle creates a delegates as a new object with
      // _target[0] = src and _target[1] = delegate function
      const o = callee as object as SaltarelleDelegate;
      if (o._targets !== undefined && o._targets.length === 2) {
        let unsafelyCastedDelegate = this.delegate as unknown as Array<SaltarelleDelegate>;
        index = unsafelyCastedDelegate.findIndex(saldel => {
          return (saldel._targets !== undefined
            && saldel._targets.length === 2
            && saldel._targets[0] === o._targets[0]
            && saldel._targets[1] === o._targets[1]);
        });
      }
    }
    return index;
  }
}

export { Delegate };
